import ExpertToolSafetyPrecautions from 'dashboard/templates/views/ExpertTool/ExpertToolSafetyPrecautions';

export default {
  path: 'safety-precautions',
  name: 'PatientExpertToolSafetyPrecautions',
  component: ExpertToolSafetyPrecautions,
  meta: {
    // title: 'Patient - Expert Tool - Safety Precautions',
    title: t => `${t('people.patient')} - ${t('expertTool.title')} - ${t('expertTool.safetyPrecautions')}`,
  },
};
